import styled from "styled-components";

export const LoginPageWrapper = styled.div`
  height: 100vh;
  background-color: #cbcccb;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1 1 auto;
`;
LoginPageWrapper.displayName = "LoginPageWrapper";

export const Logo = styled.div`
  padding: 1.5rem 0;
  flex: 1 1 auto;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
Logo.displayName = "Logo";

export const Layer = styled.div`
  background-color: rgba(255, 255, 255, 0.2);
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
Layer.displayName = "Layer";

export const Content = styled.div`
  background-image: url("https://www.morganprojects.co.nz/resources/images/services/landingflood.jpg");
  background-size: cover;
  width: 100%;
  height: 100%;
  min-height: 329px;
  top: 0px;
  left: 0px;
  opacity: 1;
  background-position: center center;
  background-repeat: no-repeat no-repeat;
`;
Content.displayName = "Content";

export const LoginCardForm = styled.div`
  display: flex;
  background-color: rgba(29, 29, 29, 0.8);
  max-width: 500px;
  min-width: 290px;
  min-height: 300px;
  width: 100%;
  box-shadow: 2px 2px rgba(0, 0, 0, 0.1);
  position: relative;
  flex-direction: column;
  word-wrap: break-word;
  background-clip: border-box;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
`;
LoginCardForm.displayName = "LoginCardForm";

export const LoginCard = styled(LoginCardForm)`
  height: 300px;
`;
LoginCard.displayName = "LoginCard";

export const FooterWrapper = styled.div`
  display: flex;
  flex: 0 0 auto;
  border-top: 1px solid hsl(0, 0%, 80%);
  flex: 1 1 auto;
  width: 100%;
  font-size: 0.8rem;
`;
FooterWrapper.displayName = "FooterWrapper";

export const Stripe = styled.div`
  position: absolute;
  width: 100%;
  height: 108px;
  background-color: #660516; // rgba(102, 5, 22);
  background-color: rgba(76, 16, 23);
`;
Stripe.displayName = "Stripe";

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  width: 100%;
  padding: 1rem 2rem 1.5rem 2rem;
`;
Form.displayName = "Form";

export const Label = styled.label`
  color: #fff;
  text-transform: uppercase;
  font-size: 1rem;
`;
Label.displayName = "Label";

export const FormGroup = styled.div`
  padding-bottom: 1rem;
  margin: 0;
`;
FormGroup.displayName = "FormGroup";

export const InputGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 0;
  width: 100%;
`;
InputGroup.displayName = "InputGroup";

export const Input = styled.input`
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  outline: none;
  background-color: #fff;
  border: 1px solid rgba(29, 29, 29);
  color: rgba(29, 29, 29);
  width: 270px;
  height: 40px
  padding-left: 0.5rem;

  box-shadow: 0;
  :focus {
    box-shadow: 0 0 5px rgba(118, 13, 23, 1);
    border: 2px solid rgba(118, 13, 23, 0.5);
    background-color: rgba(115, 115, 115);
    background-color: #fff;
    color: rgba(29, 29, 29);
  }
`;
Input.displayName = "Input";

export const ButtonWrapper = styled.div`
  display: flex;
  flex: 1 1 70px;
  align-items: flex-end;
  justify-content: flex-end;
  padding-right: 1rem;
`;
ButtonWrapper.displayName = "ButtonWrapper";

export const LinkWrapper = styled.span`
  color: #fff;
  text-decoration: underline;
  cursor: pointer;
  padding-left: 1rem;
`;
LinkWrapper.displayName = "LinkWrapper";

export const Button = styled.button`
  width: 150px;
  height: 40px;
  color: #fff;
  font-size: 15px;
  font-weight: 400;
  background-color: #7d7d7d;
  border-radius: 0px 0px 0px 0px;
  outline: none;

  :disabled {
    color: #868686;
    border-color: #868686;
    background-color: #565454;
    :hover {
      background-color: #565454;
    }
  }

  :hover {
    background-color: #656363;
  }

  :focus {
    border: 1px solid rgba(118, 13, 23, 0.5);
    outline: 1px solid rgba(118, 13, 23, 1);
    border-radius: 0;
  }
`;
Button.displayName = "Button";

export const Link = styled.a`
  color: #fff;
  padding-right: 2rem;
  vertical-align: center;
  cursor: pointer;

  :hover {
    color: rgba(118, 13, 23, 1);
  }
`;
Link.displayName = "Link";
